























import { Component, Prop, Vue } from 'vue-property-decorator';
import { IUser } from '@/interfaces/user';
import { IGroup } from '../../interfaces/group';

@Component({
  components: {
  },
})
export default class GroupUsers extends Vue {
  @Prop({ required: true })
  public group!: IGroup;

  public get users(): IUser[] {
    return this.group && this.group.users;
  }

  
}
